const HomeAcceuilleIntegrated = ({language , token}) => {
    const newHomeAcceuilleIframe = "https:" +
    window.process.env.URL_Home_VideosHome
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_homeAcceuille_display"
        src={newHomeAcceuilleIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default HomeAcceuilleIntegrated